import React from "react";
import Chart from "react-google-charts";
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input, Row } from 'reactstrap'

const pieOptions = {
    slices: [
        {
            color: "#2BB673"
        },
        {
            color: "#d91e48"
        },
        {
            color: "#007fad"
        },
        {
            color: "#e9a227"
        }
    ],
    legend: {
        alignment: "center",
        textStyle: {
            color: "233238",
            fontSize: 14
        }
    },
    tooltip: {
        showColorCode: true
    },
    chartArea: {
        // left: 0,
        // top: 0,
        width: "80%",
        height: "70%"
    },
    fontName: "Roboto",
    is3D: true
};


class MonitoringBarChart extends React.PureComponent {

    render() {
        return (<React.Fragment>
            {console.log(this.props)}
                {this.props && this.props.data && this.props.data.length > 0 ?
                   
                    <Chart
                        width={'100%'}
                        height={'100%'}
                        chartType="ColumnChart"
                        loader={<div className ="monitoring-chart-loader"/>}
                        data={this.props.data}
                        options={{
                            title: this.props.title,
                            vAxis: {
                                title: "No. of companies",
                            },
                            is3D: true,
                            chartArea: { width: '70%', height: '60%' },
                            fontName: "open_sansregular",
                            legend: {
                                position: 'none',
                                alignment: "center",
                                textStyle: {
                                    color: "233238",
                                    fontSize: 0
                                }
                            }
                        }}
                        rootProps={{ 'data-testid': '2' }}
                    /> 
                    : <div>No data Found!</div>}
            </React.Fragment>
        )
    }


}
export default MonitoringBarChart;